module.exports = __webpack_public_path__ + "img/20230706103111.f95e7495.png";